import { useNavigation } from '@zet/common/hooks/useNavigation'
import { states } from '@zet/customer/src/utils/addCustomerStates'

function useCustomerNavigation() {
  const navigation = useNavigation()
  const navigateToCustomerFlow = (paramObject, data, variables) => {
    if (
      data?.addCustomerOtpLessFlow &&
      (states[data?.action] === states.SHOW_OTP_LESS_SCREEN ||
        states[data?.action] === states.SHOW_OTP_SCREEN)
    ) {
      navigation.replace(states.SHOW_OTP_LESS_SCREEN, {
        ...paramObject,
        isOtpLessLinkShared:
          states[data?.action] === states.SHOW_OTP_LESS_SCREEN,
        isReconsentFlow: variables?.isReconsentFlow,
      })
    } else if (
      variables?.nonVerfiedUser &&
      states[data?.action] === states.SHOW_BASIC_DETAILS_SCREEN_V2
    ) {
      navigation.navigate(states[data?.action], {
        ...paramObject,
        isReconsentFlow: variables?.isReconsentFlow,
      })
    } else {
      navigation.replace(states[data?.action], {
        ...paramObject,
        ...data,
        isReconsentFlow: variables?.isReconsentFlow,
        isExperianEnabled: data?.actionData?.isExperianEnabled,
      })
    }
  }
  return {
    navigateToCustomerFlow,
  }
}

export { useCustomerNavigation }
